export default __webpack_public_path__ + "static/nextGenerationMechanicalHotPipMobile-5936b9c5dcca05985f7247fe0d1cdc7d.png";